import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getICCategoryOptions,
    getICTypeOptions,
    getInvoiceTypesOptions,
    getMyDataRowTypes, getVatExpenseClassificationType
} from "../../../../_helpers/sharedmydata";
import {
    newProductsCategoryMyDataInitialValue,
    setNewProductsCategoryMyData
} from "../../../../_reducers/DataPanel/Products/productCategorySlice";
import {setEditAccountingAccount} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {quickClone} from "../../../../_helpers/commonFunctions";
import EditableTable from "../../../primer/Editable-Table";
import {setSaveEditAccountingAccount} from "../../../../_reducers/activitySlice";
import {useTranslation} from "../../../../hooks/useTranslation";

const AccountingAccountEditMyData = () => {
    const {t} = useTranslation();
    const saveEditAccountingAccount = useSelector((state) => state.ACTIVITY.saveEditAccountingAccount);
    const editAccountingAccount = useSelector((state) => state.ACCOUNTING_DATA.editAccountingAccount);
    const newProductsCategoryMyData = useSelector(state => state.PRODUCTS_CATEGORY.newProductsCategoryMyData);

    const dispatch = useDispatch();
    const invoiceTypes = getInvoiceTypesOptions();
    const icCategory = getICCategoryOptions();
    const icType = getICTypeOptions();
    const myDataRowTypes = getMyDataRowTypes();
    const vatExpenseTypes = getVatExpenseClassificationType();

    const productsColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "10%",
            editable: true,
            inputType: {
                type: 'select',
                options: myDataRowTypes
            }
        },
        {
            name: t('ProductsSettings.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                multiselect: true,
                options: invoiceTypes
            }
        },
        {
            name: t('ProductsSettings.table.category'),
            field: "category",
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: icCategory
            }
        },
        {
            name: t('ProductsSettings.table.type'),
            field: 'type',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: icType
            }
        },
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: vatExpenseTypes,
            }
        }
    ];
    const parentMydataActions = {
        insert: (e, data) => {
            if (!saveEditAccountingAccount) dispatch(setSaveEditAccountingAccount(true));
            let tempPcMyData = Object.assign({}, newProductsCategoryMyData);
            if (e.key !== "Enter") {
                tempPcMyData[data.field] = data.value;
                dispatch(setNewProductsCategoryMyData(tempPcMyData)); // Update redux my data values
            }
            // If validated fields done add new row
            if (tempPcMyData.rowType !== '' || tempPcMyData.invoiceType !== '' || tempPcMyData.category !== '' || tempPcMyData.type !== '') {
                let updateNewPcMydata = Object.assign({}, newProductsCategoryMyData);
                updateNewPcMydata.id = editAccountingAccount.mydata.length + 1;
                // set the last updated value
                if (tempPcMyData.type) {
                    updateNewPcMydata.type = tempPcMyData.type;
                }
                if (tempPcMyData.rowType) {
                    updateNewPcMydata.rowType = tempPcMyData.rowType;
                }
                if (tempPcMyData.invoiceType) {
                    updateNewPcMydata.invoiceType = tempPcMyData.invoiceType;
                }
                if (tempPcMyData.category) {
                    updateNewPcMydata.category = tempPcMyData.category;
                }
                let accountingCategory = Object.assign({}, editAccountingAccount);
                let updatedMyData = Array.isArray(accountingCategory.mydata) ? [...accountingCategory.mydata, updateNewPcMydata] : [updateNewPcMydata];
                dispatch(setEditAccountingAccount({...accountingCategory, mydata: updatedMyData}));
                dispatch(setNewProductsCategoryMyData(newProductsCategoryMyDataInitialValue)); // Reset new category mydata
            }
        },
        update: (data, id) => {
            if (!saveEditAccountingAccount) dispatch(setSaveEditAccountingAccount(true));
            let selectedCategoryMyData = Object.assign([], editAccountingAccount.mydata);
            if (selectedCategoryMyData.find(item => item.id === id) !== undefined) {
                let accountingCategory = Object.assign({}, editAccountingAccount);
                selectedCategoryMyData[id - 1] = {...selectedCategoryMyData[id - 1], ...data};
                if (data.invoiceType) {
                    selectedCategoryMyData[id - 1].category = "";
                    selectedCategoryMyData[id - 1].type = "";
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                } else if (data.category) {
                    selectedCategoryMyData[id - 1].type = "";
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                } else if (data.type) {
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                }
                dispatch(setEditAccountingAccount({...accountingCategory, mydata: selectedCategoryMyData}));
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditAccountingAccount) dispatch(setSaveEditAccountingAccount(true));
            const cloneIt = quickClone(editAccountingAccount.mydata);
            cloneIt.splice(rowIndex, 1);
            cloneIt.forEach((row, idx) => {
                row.no = String(idx + 1);
                row.id = String(idx + 1);
            })
            dispatch(setEditAccountingAccount({...editAccountingAccount, mydata: cloneIt}));
        }
    }

    return (
        <>
            <br/>
            <p className="text-center border-bottom pb-3 pt-3 "><i>{t('ProductsSettings.categorySettings')}</i></p>
            <div className="row">
                <div className="col-12">
                    <p className="text-muted"><i>{t('ProductsSettings.proposedMyDataValue')}</i></p>
                    <EditableTable
                        tableName="Product Category My Data" // Do not change name
                        showAccounting={true}
                        key={Math.random()}
                        onUpdate={parentMydataActions}
                        allowActions={true}
                        allowInsertRow={true}
                        columns={productsColumns}
                        data={editAccountingAccount?.mydata ? editAccountingAccount?.mydata : []}
                        enableNewRowCheckbox={true}
                    />
                </div>
            </div>
            <hr/>
        </>
    )
}
export default AccountingAccountEditMyData;
